import request from '@/utils/request'
import {
  getToken,
  getApplicationId
} from '@/utils/auth'
/**
 * 邮箱认证
 */
export function sendVerifyMail(data) {
  return request({
    url: '/app-api/ph2/form-applications/send-verify-mail',
    method: 'post',
    data: data
  })
}

/**
 * 查询状态邮箱认证
 */
export function sendQueryVerifyMail(data) {
  return request({
    url: '/app-api/ph2/form-applications/send-query-verify-mail',
    method: 'post',
    data: data
  })
}

/**
 * 继续填写邮箱认证
 */
export function sendContinueVerifyMail(data) {
  return request({
    url: '/app-api/ph2/form-applications/send-continue-verify-mail',
    method: 'post',
    data: data
  })
}
/**
 * 继续填写申请获取token
 * @param {*} data 
 * @returns 
 */
export function continueFillForm(data) {
  return request({
    url: '/app-api/ph2/form-applications/continue-fill-form',
    method: 'post',
    data: data
  })
}
/**
 * 
 * @returns 獲取表單信息
 */
export function queryFormData() {
  return request({
    url: "/app-api/ph2/form-applications/form-data",
    method: "post",
    data: {
      "id": getApplicationId(),
      "token": getToken()
    }
  })
}


/**
 * 创建申请人信息并获取token
 * @param {*} data 
 * @returns 
 */
export function create(data) {
  return request({
    url: '/app-api/ph2/form-applications/create',
    method: 'post',
    data: data
  })
}

/**
 * 提交申请住屋，生活材料
 * @param {*} data 
 * @returns 
 */
export function liveEmploymentForm(data) {
  data.applicationId = getApplicationId();
  data.token = getToken();
  return request({
    url: '/app-api/ph2/form-applications/live-employment-form',
    method: 'post',
    data: data
  })
}

export function eligibilityDeclarationForm(data) {
  data.applicationId = getApplicationId();
  data.token = getToken();
  return request({
    url: '/app-api/ph2/form-applications/eligibility-declaration-form',
    method: 'post',
    data: data
  })
}

/**
 * 查詢申請狀態
 * @param {*} data 
 * @returns 
 */
export function queryFormStatus(data) {
  return request({
    url: '/app-api/ph2/form-applications/query-form-status',
    method: 'post',
    data: data
  })
}
/**
 * 提交申明、條款
 * @param {*} data 
 * @returns 
 */
export function declaretionConditionForm(data) {
  data.applicationId = getApplicationId();
  data.token = getToken();
  return request({
    url: '/app-api/ph2/form-applications/declaretion-condition-form',
    method: 'post',
    data: data
  })
}

/**
 * 文件上传表单数据提交
 * @param {*} data 
 * @returns 
 */
export function fileUploadForm(data) {
  data.applicationId = getApplicationId();
  data.token = getToken();
  return request({
    url: '/app-api/ph2/form-applications/file-upload-form',
    method: 'post',
    data: data
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(type) {
  return request({
    url: '/app-api/system/dict-data/type?type=' + type,
    method: 'get'
  })
}

/**
 * 获取内容，首页、声明等信息
 * @param {*} code 
 * @returns 
 */
export function getContent(code) {
  return request({
    url: '/app-api/ph2/context/get?code=' + code,
    method: 'get'
  })
}

/**
 * 刪除附件
 * @param {*} fileId 
 */
export function deleteFile(fileId){
  return request({
    url: '/app-api/infra/file/delete?id=' + fileId,
    method: 'delete'
  })
 
}




// WEBPACK FOOTER //
// ./src/assets/js/api.js